import React, { memo, useEffect, useState, useImperativeHandle } from 'react';
import { Form, Input, Button } from 'antd';
import { individualBuyerData } from '@model/projectDetails';
import { connect } from 'react-redux';
import action from '@flux/action';
import useTheme from '@hooks/useTheme';
import { scrollToTopAnimation } from '@utils/common';
const Item = Form.Item;
const { TextArea } = Input;

function ClientCompany(props) {
  const { theme } = useTheme();
  const isLightMode = theme === 'light';
  const { settingProjectData, settingData, cRef, common } = props;
  const [form] = Form.useForm();
  const [scrollToTop] = useState();
  const data = {};
  useImperativeHandle(cRef, () => ({
    subOneForm: form,
  }));
  useEffect(() => {
    scrollToTopAnimation({ y: 260 });
  }, [scrollToTop]);
  settingData.buyerCompanyInfo &&
    Object.keys(settingData.buyerCompanyInfo).map((item) => {
      if (
        item === 'employeeHeadcount' ||
        item === 'estimatedTotalRevenue' ||
        item === 'estimatedMarketCap'
      ) {
        data[`SUBONE${item}`] = settingData.buyerCompanyInfo[item]
          ? `${settingData.buyerCompanyInfo[item]}`.replace(
              /(\d)(?=(\d{3})+$)/g,
              '$1,',
            )
          : '';
      } else {
        data[`SUBONE${item}`] = settingData.buyerCompanyInfo[item];
      }
      return data;
    });
  const renderItem = (item, idx) => {
    if (item.type === 'Input') {
      return (
        <Item
          label={item.label}
          name={item.name}
          style={{ ...item.style }}
          key={item.name + idx}
          rules={[
            {
              required: item.required,
              whitespace: true,
              pattern: item.pattern,
              message: item.message,
            },
          ]}
        >
          <Input
            maxLength={255}
            onChange={(e) => {
              const itemName = item.name && item.name.substring(6);
              let val;
              if (
                e.target.value &&
                (itemName === 'employeeHeadcount' ||
                  itemName === 'estimatedTotalRevenue' ||
                  itemName === 'estimatedMarketCap')
              ) {
                const num = e.target.value.replace(/,/g, '');
                form.setFieldsValue({
                  [item.name]: num.replace(/(\d)(?=(\d{3})+$)/g, '$1,'),
                });
                val = Number(form.getFieldValue(item.name).replace(/,/g, ''));
                form.validateFields([item.name]);
              } else {
                val = e.target.value;
              }

              settingProjectData({
                buyerCompanyInfo: {
                  ...settingData.buyerCompanyInfo,
                  [itemName]: val,
                },
              });
            }}
          />
        </Item>
      );
    } else if (item.type === 'Div') {
      return (
        <div
          style={{
            ...item.style,
            ...(isLightMode ? { color: '#474747' } : {}),
          }}
          key={item.name + idx}
        >
          {item.text}
          <span style={{ fontWeight: 700 }}>{item.companyName}</span>
        </div>
      );
    } else if (item.type === 'textArea') {
      return (
        <Item
          label={item.label}
          name={item.name}
          style={{ ...item.style }}
          key={item.name + idx}
        >
          <TextArea
            style={{ resize: 'none' }}
            onChange={(e) => {
              const itemName = item.name && item.name.substring(6);
              const val = e.target.value;

              settingProjectData({
                buyerCompanyInfo: {
                  ...settingData.buyerCompanyInfo,
                  [itemName]: val,
                },
              });
            }}
          />
        </Item>
      );
    }
    return null;
  };
  const onFinish = () => {
    settingProjectData({ currentNum: 3 });
  };

  const skipHandler = () => {
    if (settingData.targetManualInputFlag) {
      settingProjectData({ currentNum: 3 });
    } else {
      settingProjectData({ currentNum: 1 });
    }
    const buyerCompanyInfoForSkip = {
      name: null,
      parentCompany: null,
      companyWebsite: null,
      description: null,
      industry: null,
      headquarters: null,
      incorporationDate: null,
      employeeHeadcount: null,
      estimatedTotalRevenue: null,
      estimatedMarketCap: null,
    };
    settingProjectData({ buyerCompanyInfo: buyerCompanyInfoForSkip });
  };

  const showSkipBtn = !common?.projectCompanyInfo?.buyerName;

  return (
    <Form
      onFinish={onFinish}
      name="createProject"
      form={form}
      initialValues={data}
      layout="vertical"
      autoComplete="off"
    >
      {Array.isArray(individualBuyerData) &&
        individualBuyerData.map((item, idx) => renderItem(item, idx))}
      <div className="form-actions-wrapper setting-btns">
        <Button
          className="previous-btn"
          onClick={() => {
            if (showSkipBtn) {
              settingProjectData({ currentNum: 1 });
            } else {
              form
                .validateFields()
                .then(() => {
                  settingProjectData({ currentNum: 1 });
                })
                .catch((err) => {
                  console.log(err);
                });
            }
          }}
        >
          previous
        </Button>
        {showSkipBtn ? (
          <Button className="skip-btn" onClick={skipHandler}>
            skip
          </Button>
        ) : null}
        {Boolean(settingData.targetManualInputFlag) && (
          <Button className="ok-btn" htmlType="submit">
            next
          </Button>
        )}
      </div>
    </Form>
  );
}

const mapStateToProps = ({ projects, common }) => ({
  settingData: projects.settingData,
  common,
});

const mapDispatchToProps = (dispatch) => ({
  settingProjectData(data) {
    dispatch(action.settingProjectData(data));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(memo(ClientCompany));
